import { BrowserRouter as Router } from 'react-router-dom';
import ResidentRoutes from './routes/ResidentRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SplashScreen from './components/splashscreen';
import { useState } from 'react';
import { SettingsProvider } from './context/SettingContext';

function App() {

    const [showSplash,setshowSplash]=useState(()=>{
         return !sessionStorage.getItem('splashShown');
    })

       const handleSplashFinish = () => {
        sessionStorage.setItem('splashShown', 'true');
        setshowSplash(false);
    };

    return (
       <>
            <SettingsProvider>
            <ToastContainer position="top-right" />
            
            {showSplash ? (
                <SplashScreen onFinish={handleSplashFinish} />
            ) : (
                <Router>
                    <ResidentRoutes />
                    {/* Other routes */}
                </Router>
            )}
            </SettingsProvider>

        </>
    );
}

export default App;